module.exports = __webpack_public_path__ + "static/ricopertura-2efaa2af573ee42b28782006945ae43b.jpg";